export const DateOptions = Object.freeze({
  MONTH: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
});

export const DateOptionNames = Object.freeze({
  MONTH: 'birthMonth',
  DAY: 'birthDay',
});

export const DateOptionLabels = Object.freeze({
  MONTH: 'Month',
  DAY: 'Day',
  YEAR: 'Year',
});

export const FormSelectComponents = Object.freeze({
  SELECT_DAY: 'selectDay',
  SELECT_MONTH: 'selectMonth',
  SELECT_YEAR: 'selectYear',
});
